var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "456px",
    height: "456px",
    viewBox: "0 0 456 456",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    fill: "#020202",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228,279.52 C169.762,279.52 122.72,232.481 122.72,174.24 C122.72,116.002 169.763,68.96 228,68.96 C286.237,68.96 333.28,115.999 333.28,174.24 C333.28,232.482 286.237,279.52 228,279.52 Z M228,113.76 C194.398,113.76 167.52,141.201 167.52,174.24 C167.52,207.279 194.399,234.717 228,234.717 C261.601,234.717 288.48,207.276 288.48,174.237 C288.48,141.198 261.601,113.76 228,113.76 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.24,373.6 C354.5603,369.6781 352.3181,365.2016 349.5212,361.28 C337.2012,342.8 318.7202,330.479 298.0012,325.999 C277.2822,339.44 253.2002,346.718 228.0012,346.718 C202.8022,346.718 178.7202,339.4368 158.0012,325.999 C137.2822,330.4795 118.2392,342.8 106.4812,361.28 C103.6804,365.2019 101.4421,369.1198 99.7624,373.6 L58.8834,355.678 C61.6842,348.9592 65.0436,342.799 69.5244,336.639 C89.6844,306.401 122.1654,286.241 158.0044,281.198 C165.8442,280.0769 173.6844,282.3191 179.8444,286.7996 C193.8444,296.8776 210.6454,302.4796 228.5634,302.4796 C246.4854,302.4796 263.2824,296.878 277.2824,286.7996 C283.4426,282.3191 291.2824,280.0808 299.1224,281.198 C334.9624,286.2371 367.4424,306.397 387.6024,336.639 C391.5243,342.7992 394.8836,348.959 398.2434,355.678 L356.24,373.6 Z M303.6,322.639 C303.6,322.639 303.0375,322.639 303.6,322.639 C303.0375,322.639 303.6,322.639 303.6,322.639 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,455.92 C102.56,455.92 0.08,353.44 0.08,228 C0.08,102.56 102.56,0.08 228,0.08 C353.44,0.08 455.92,102.56 455.92,228 C455.92,353.44 353.44,455.92 228,455.92 L228,455.92 Z M228,44.88 C127.2,44.88 44.88,127.2 44.88,228 C44.88,328.8 127.2,411.12 228,411.12 C328.8,411.12 411.12,328.8 411.12,228 C411.12,127.2 328.8,44.88 228,44.88 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.6e4fa597e47cf00705c1797cb1bc765b.svg";
export { ForwardRef as ReactComponent };